export const DEFAULT_LANGUAGE = 'sv'
export const FALLBACK_LANGUAGE = 'sv'
export const SUPPORTED_LANGUAGES = ['sv', 'en']
